import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Job {
  jobCity?: string;
  region?: string;
  country?: string;
  // You can add other fields here
}

interface CreateJobState {
  job: Job;
}

const initialState: CreateJobState = {
  job: {
    jobCity: '',
    region: '',
    country: ''
  }
};

const createJobSlice = createSlice({
  name: 'createJob',
  initialState,
  reducers: {
    updateJobFields: (state, action: PayloadAction<Job>) => {
      state.job = { ...state.job, ...action.payload };
    }
  }
});

export const { updateJobFields } = createJobSlice.actions;

export default createJobSlice.reducer;
